import { formatCustomDate } from "helpers/dateTools";
import { ActionTypes } from "./types";
import { orderArrayV2 } from "helpers/orderArray";

const {
    GET_INVENTORY_STATUS_NFC,
    GET_INVENTORY_STATUS_CLOSED,
    GET_INVENTORY_STATUS_REASONS,
    GET_INVENTORY_STATUS_PERCENTAGES,
    GET_INVENTORY_STATUS_COMPLETE,
    GET_INVENTORY_STATUS_INCOMPLETE,
    GET_INVENTORY_STATUS_SYNC,
    CLOSE_INVENTORY_STATUS,
    CREATE_INVENTORY_STATUS,
    EDIT_INVENTORY_STATUS,
    DELETE_INVENTORY_STATUS,
    SET_INVENTORY_STATUS_FILTERS,
    CLEAR_INVENTORY_STATUS,
} = ActionTypes

const INITIAL_STATE = {
    allowClosure: false,
    inventoryPercentage: 0,
    inventoryComplete: [],
    inventoryIncomplete: [],
    closurePercentage: null,
    closure: null,
    nfcOptions: [],
    reasonsOptions: [],
    inventorySync: {},
    date: formatCustomDate(new Date(), "-"),
    station: null,
    unitType: [],
    snackBar: {
        msg: "",
        isOpen: false
    },
}

export const inventoryStatusReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case SET_INVENTORY_STATUS_FILTERS:
            return {
                ...state,
                [payload.key]: payload.data,
            };
        case CLEAR_INVENTORY_STATUS:
            return {
                ...state,
                ...INITIAL_STATE,
            };
        case GET_INVENTORY_STATUS_NFC:
            return {
                ...state,
                nfcOptions: payload,
            };
        case GET_INVENTORY_STATUS_CLOSED:
            return {
                ...state,
                closurePercentage: payload.closurePercentage,
                allowClosure: payload.allowClosure,
                closure: payload.closure?.id
            };
        case GET_INVENTORY_STATUS_REASONS:
            return {
                ...state,
                reasonsOptions: payload,
            };
        case GET_INVENTORY_STATUS_PERCENTAGES:
            return {
                ...state,
                inventoryPercentage: payload.percentage,
            };
        case GET_INVENTORY_STATUS_COMPLETE:
            let formattedDatesComplete = payload.map(inventory => ({ ...inventory, date: formatCustomDate(inventory.date, "-") }))
            formattedDatesComplete = orderArrayV2(formattedDatesComplete, 'unit')
            return {
                ...state,
                inventoryComplete: formattedDatesComplete,
            };
        case GET_INVENTORY_STATUS_INCOMPLETE:
            let formattedDatesIncomplete = payload.map(inventory => ({ ...inventory, date: formatCustomDate(inventory.date, "-") }))
            formattedDatesIncomplete = orderArrayV2(formattedDatesIncomplete, 'unit')
            return {
                ...state,
                inventoryIncomplete: formattedDatesIncomplete,
            };
        case GET_INVENTORY_STATUS_SYNC:
            return {
                ...state,
                inventorySync: payload,
            };
        case CLOSE_INVENTORY_STATUS:
            return {
                ...state,
                closure: payload?.id,
                allowClosure: !state.allowClosure,
            };
        case CREATE_INVENTORY_STATUS:
            const incompleteState = state.inventoryIncomplete
            const completeState = state.inventoryComplete
            const incompleteFiltered = incompleteState.filter(inv => inv.idTank !== payload.idTank)
            const completedAdded = [payload, ...completeState]
            return {
                ...state,
                inventoryIncomplete: incompleteFiltered,
                inventoryComplete: completedAdded
            };
        case EDIT_INVENTORY_STATUS:
            const completeStateList = state.inventoryComplete.map(inv =>
                inv.id === payload.id ? payload : inv
            )
            return {
                ...state,
                inventoryComplete: completeStateList
            };
        case DELETE_INVENTORY_STATUS:
            const { id, ...rest } = payload
            const completeStateArr = state.inventoryComplete
            const completeFiltered = completeStateArr.filter(inv => inv.id !== id)
            return {
                ...state,
                inventoryComplete: completeFiltered,
                inventoryIncomplete: [...state.inventoryIncomplete, rest]
            };
        default:
            return state;
    }
}